// PvP e Herói (documento de design): lutas automáticas só contra a mesma vocation, na fila de batalha.
// Ciclo de 48 horas; 10 lutas por dia; mínimo de 12 lutas no ciclo para ser Herói; um Herói por vocation;
// pontuação no estilo das Olimpíadas do Lineage 2; no máximo 2 lutas contra o mesmo oponente por ciclo; level mínimo 100.
// Bônus do Herói: +5% de XP, dano PvE, vida e mana durante o ciclo seguinte.
export const PVP_CYCLE_MS = 48 * 3600_000;
export const PVP_DAILY = 10;
export const PVP_MIN_FIGHTS = 12;
export const PVP_MIN_LEVEL = 100;
export const PVP_MAX_VS = 2;
export const PVP_START_POINTS = 18;   // como nas Olimpíadas do L2
export const HERO_BONUS_PCT = 5;
/** pontos que passam do perdedor para o vencedor: 1/5 dos pontos do perdedor, entre 1 e 10 (proposta) */
export const pvpTransfer = (loserPts: number) => Math.max(1, Math.min(10, Math.ceil(loserPts / 5)));
/** faixa de pareamento: 5 pontos + 5 a cada 15 s de espera (proposta) */
export const pvpRange = (waitMs: number) => 5 + Math.floor(waitMs / 15_000) * 5;
/** ciclo atual (índice e quando acaba), contado em blocos de 48 h a partir de 01/01/2026 às 00:00 de Brasília */
const EPOCH = Date.UTC(2026, 0, 1, 3);
export function pvpCycle(now = Date.now()): { id: string; ends: number } {
  const n = Math.floor((now - EPOCH) / PVP_CYCLE_MS);
  return { id: 'c' + n, ends: EPOCH + (n + 1) * PVP_CYCLE_MS };
}
export interface PvpRow { name: string; vocation: string; level: number; points: number; fights: number; wins: number }
